/* Keep the selected category visible within its tab row without scrolling the page. */
(() => {
  const MANTEL_QUERY = 'jacc_view=mantel&filter.p.product_type=Mantel%20Clock&filter.p.product_type=Mechanical%20Mantel%20Clock&filter.p.product_type=Weather%20House';
  const TABLE_QUERY = 'jacc_view=table&filter.p.product_type=Table%20Clock&filter.p.product_type=Mechanical%20Table%20Clock&filter.p.product_type=Mechanical%20Table%20Regulator&filter.p.product_type=Mechanical%20Carriage%20Clock&filter.p.product_type=Desk%20Clock&filter.p.product_type=Alarm%20Clock&filter.p.product_type=Table%2F%20Wall%20Clock&filter.p.product_type=Weather%20House&filter.p.product_type=Clock%20Table&filter.p.product_type=Vintage%20Alarm%20Clock&filter.p.product_type=Chart%20Weight&filter.p.product_type=Weather%20Station';

  function showCurrentCategory(root = document) {
    root.querySelectorAll('[data-jacc-collection-tabs]').forEach((nav) => {
      const current = nav.querySelector('[aria-current="page"]');
      if (!current || nav.scrollWidth <= nav.clientWidth) return;
      const row = nav.getBoundingClientRect();
      const tab = current.getBoundingClientRect();
      if (tab.left < row.left || tab.right > row.right) {
        nav.scrollLeft += tab.left - row.left - (row.width - tab.width) / 2;
      }
    });
  }

  function makeTab(label, href, active) {
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.textContent = label;
    a.href = href;
    if (active) a.setAttribute('aria-current', 'page');
    li.append(a);
    return li;
  }

  function splitMantelTableTab(root) {
    const family = root.dataset.jaccCollectionFamily || '';
    if (family !== 'all-clocks' && family !== 'cuckoo' && family !== 'howard-miller') return;

    const combinedHandle = family === 'howard-miller'
      ? 'howard-miller-mantel-table-clocks'
      : 'mantel-table-clocks';
    const nav = root.querySelector('[data-jacc-collection-tabs]');
    if (!nav || nav.dataset.jaccMantelTableSplit === 'true') return;

    const anchor = Array.from(nav.querySelectorAll('a')).find((a) => {
      try { return new URL(a.href, location.origin).pathname.includes(`/collections/${combinedHandle}`); }
      catch (_) { return false; }
    });
    if (!anchor) return;

    const row = anchor.closest('li');
    if (!row) return;

    const base = `/collections/${combinedHandle}?`;
    const params = new URLSearchParams(location.search);
    const view = params.get('jacc_view');
    const onCombined = location.pathname.includes(`/collections/${combinedHandle}`);

    const useCompactLabels = family === 'all-clocks' || family === 'cuckoo';
    row.replaceWith(
      makeTab(useCompactLabels ? 'Mantel' : 'Mantel clocks', base + MANTEL_QUERY, onCombined && view === 'mantel'),
      makeTab(useCompactLabels ? 'Table & desk' : 'Table & Desk clocks', base + TABLE_QUERY, onCombined && view === 'table')
    );
    nav.dataset.jaccMantelTableSplit = 'true';
  }

  function applyVirtualLanding(root) {
    const params = new URLSearchParams(location.search);
    const view = params.get('jacc_view');
    if (view !== 'mantel' && view !== 'table') return;

    const family = root.dataset.jaccCollectionFamily || '';
    const combinedHandle = family === 'howard-miller'
      ? 'howard-miller-mantel-table-clocks'
      : family === 'all-clocks'
        ? 'mantel-table-clocks'
        : '';
    if (!combinedHandle || !location.pathname.includes(`/collections/${combinedHandle}`)) return;

    const heading = root.querySelector('.jacc-comitti-hero__copy h1');
    const intro = root.querySelector('.jacc-comitti-hero__intro');
    const crumb = root.querySelector('.jacc-comitti-breadcrumb [aria-current="page"]');
    const image = root.querySelector('.jacc-comitti-hero__image');
    const caption = root.querySelector('.jacc-pictured-caption');

    const isHoward = family === 'howard-miller';
    root.classList.toggle('jacc-virtual-table-hero', isHoward && view === 'table');
    root.classList.toggle('jacc-virtual-mantel-hero', !isHoward && view === 'mantel');
    if (view === 'mantel') {
      if (heading) heading.textContent = 'Mantel clocks';
      document.title = isHoward
        ? 'Howard Miller Mantel Clocks | Just A Clock Collector'
        : 'Mantel Clocks for Sale | Just A Clock Collector';
      if (intro) intro.textContent = isHoward
        ? 'Howard Miller mantel clocks for shelves, mantels and traditional focal points.'
        : 'Mantel clocks for shelves, mantels and traditional focal points.';
      if (crumb) crumb.textContent = 'Mantel clocks';

      // Give the virtual Mantel destination its own hero/caption when configured.
      if (!isHoward && image && root.dataset.jaccMantelHero) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = root.dataset.jaccMantelHero;
        image.alt = root.dataset.jaccMantelAlt || 'Mantel clock in a styled interior';
      }
      if (caption && root.dataset.jaccMantelLabel) {
        const label = root.dataset.jaccMantelLabel;
        const url = root.dataset.jaccMantelUrl || '#';
        caption.hidden = false;
        caption.innerHTML = '';
        const prefix = document.createElement('span');
        prefix.className = 'jacc-pictured-caption__prefix';
        prefix.textContent = 'Pictured';
        const separator = document.createElement('span');
        separator.className = 'jacc-pictured-caption__separator';
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = ' · ';
        const link = document.createElement('a');
        link.className = 'jacc-pictured-caption__label jacc-pictured-caption__link';
        link.href = url;
        link.textContent = label;
        link.setAttribute('aria-label', `View ${label}`);
        caption.append(prefix, separator, link);
      }
    } else {
      if (heading) heading.textContent = 'Table & Desk clocks';
      document.title = isHoward
        ? 'Howard Miller Table & Desk Clocks | Just A Clock Collector'
        : 'Table & Desk Clocks for Sale | Just A Clock Collector';
      if (intro) intro.textContent = isHoward
        ? 'Howard Miller tabletop and desk clocks for shelves, desks and smaller spaces.'
        : 'Compact clocks for desks, shelves, consoles and smaller spaces.';
      if (crumb) crumb.textContent = 'Table & Desk clocks';

      // The combined collection heroes are not shared between the two virtual destinations.
      // Swap Table / Desk to a genuine tabletop hero and keep the pictured product shoppable.
      if (image && root.dataset.jaccTableHero) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = root.dataset.jaccTableHero;
        image.alt = root.dataset.jaccTableAlt || 'Table clock in a styled interior';

        if (caption) {
          const label = root.dataset.jaccTableLabel || 'Table clock';
          const url = root.dataset.jaccTableUrl || '#';
          caption.hidden = false;
          caption.innerHTML = '';
          const prefix = document.createElement('span');
          prefix.className = 'jacc-pictured-caption__prefix';
          prefix.textContent = 'Pictured';
          const separator = document.createElement('span');
          separator.className = 'jacc-pictured-caption__separator';
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = ' · ';
          const link = document.createElement('a');
          link.className = 'jacc-pictured-caption__label jacc-pictured-caption__link';
          link.href = url;
          link.textContent = label;
          link.setAttribute('aria-label', `View ${label}`);
          caption.append(prefix, separator, link);
        }
      }
    }

    const details = document.querySelector('.jacc-comitti-details__inner');
    if (details) {
      details.textContent = view === 'table'
        ? (isHoward
            ? 'Shop Howard Miller table and desk clocks for shelves, desks, consoles and smaller spaces. Compare dimensions, finishes and quartz features on each product page.'
            : 'Shop table and desk clocks for shelves, desks, consoles and smaller spaces. Compare dimensions, finishes and movement details on each product page.')
        : (isHoward
            ? 'Shop Howard Miller mantel clocks for shelves, mantels and traditional focal points. Compare dimensions, finishes, movement and sound details on each product page.'
            : 'Shop mantel clocks for shelves, mantels and traditional focal points. Compare dimensions, finishes, movement and sound details on each product page.');
    }

    if (view === 'table') {
      const guidance = document.querySelector('jacc-collection-guidance.jacc-guidance');
      if (guidance) {
        const h = guidance.querySelector('h2');
        if (h) h.textContent = 'The right clock for your desk or shelf.';
        const introText = h?.nextElementSibling;
        if (introText?.tagName === 'P') introText.textContent = 'A few practical details make the difference on a desk, shelf or console.';
        const about = guidance.querySelector('.jacc-guidance__send-row p span');
        if (about) about.textContent = isHoward ? 'Howard Miller Table & Desk Clocks' : 'Table & Desk Clocks';
      }
    }
  }

  function enhance(root = document) {
    root.querySelectorAll('[data-jacc-collection-family]').forEach((gallery) => {
      splitMantelTableTab(gallery);
      applyVirtualLanding(gallery);
    });
    requestAnimationFrame(() => showCurrentCategory(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  } else {
    enhance();
  }
  document.fonts?.ready.then(() => showCurrentCategory());
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();

